export default class ConfirmationPage {
    constructor() {
        window.addEventListener('DOMContentLoaded', () => {
            const confirmationMessage = document.querySelector('.woocommerce-thankyou-order-received');
            confirmationMessage.innerHTML =
                'Thank you! No need to refresh, you’re about to be fresh.';

            const confirmationHeadline = document.querySelector('h2.has-text-align-center');
            confirmationHeadline.innerHTML = "Your order's complete";
        });
    }
}
